import type {PageRouteConfig} from '@router';

import {type HeaderDataPayload} from '@ds/types';
import {useRouteBuildContext} from '@router';
import PromotionCenterCampaign from 'modules/Services/PromotionCenter/Campaign/Campaign';

function PromotionCenterCampaignPageElement() {
  const ctx = useRouteBuildContext();

  return (
    <PromotionCenterCampaign
      headerData={({icon, action, iconTitle, title}: HeaderDataPayload) => {
        ctx.updateHeaderData('promotionCenter', {icon, action, iconTitle, title});
      }}
    />
  );
}

export function createPromotionCenterCampaignRoute(): PageRouteConfig {
  return {
    element: <PromotionCenterCampaignPageElement />,
    layout: {
      title: 'انتخاب کالاها و درصد تخفیف',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: true,
      link: -1,
      headerDataKey: 'promotionCenter'
    },
    initialHeaderData: {
      promotionCenter: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
